/**
 * Hover glow — product card images get a warm golden glow on hover.
 * Pure CSS injection, no transforms (safe for fixed-position ancestors).
 * Desktop only, respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var style = document.createElement('style');
  style.textContent =
    'product-card .card-gallery,' +
    '.collection-card .collection-card__inner{' +
      'transition:box-shadow 0.4s ease,filter 0.4s ease;' +
    '}' +
    'product-card:hover .card-gallery,' +
    '.collection-card:hover .collection-card__inner{' +
      'box-shadow:0 4px 24px rgba(212,175,55,0.18),0 0 0 1px rgba(212,175,55,0.08);' +
      'filter:brightness(1.03);' +
    '}' +
    '.mega-menu__link-image{transition:filter 0.3s ease,box-shadow 0.3s ease;}' +
    '.mega-menu__link:hover .mega-menu__link-image{' +
      'filter:brightness(1.05);' +
      'box-shadow:0 2px 12px rgba(212,175,55,0.15);' +
    '}';
  document.head.appendChild(style);
})();
